import type { Node } from "@xyflow/react";
import { frameNodeDimension } from "@/lib/frame-node-geometry";

const DEFAULT_GAP = 32;

export function nextFramePosition({
  nodes,
  frameSize,
  viewportCenter,
  viewportWidth,
  gap = DEFAULT_GAP,
}: {
  nodes: Node[];
  frameSize: { width: number; height: number };
  viewportCenter: { x: number; y: number };
  viewportWidth: number;
  gap?: number;
}): { x: number; y: number } {
  if (nodes.length === 0) {
    return {
      x: Math.round(viewportCenter.x - frameSize.width / 2),
      y: Math.round(viewportCenter.y - frameSize.height / 2),
    };
  }

  let rightmostEdge = -Infinity;
  let bottomEdge = -Infinity;
  for (const node of nodes) {
    const right = node.position.x + frameNodeDimension(node, "width");
    const bottom = node.position.y + frameNodeDimension(node, "height");
    if (right > rightmostEdge) rightmostEdge = right;
    if (bottom > bottomEdge) bottomEdge = bottom;
  }

  const candidateX = rightmostEdge + gap;
  const viewportRightEdge = viewportCenter.x + viewportWidth / 2;
  if (candidateX + frameSize.width > viewportRightEdge + viewportWidth) {
    return {
      x: Math.round(viewportCenter.x - frameSize.width / 2),
      y: Math.round(bottomEdge + gap),
    };
  }

  return {
    x: Math.round(candidateX),
    y: Math.round(viewportCenter.y - frameSize.height / 2),
  };
}
